export const UserGetSchema = {
    id: 'id',
    pages: {
        general: {
            pageId: 'general',
            firstName: 'firstName',
            lastName: 'lastName',
            title: 'title',
            organization: 'organization',
            email: 'email',
            additionalEmails: 'additionalEmails',
            role: 'role',
            password: 'password',
            comment: 'comment',
            isBypassRadiusAuth: 'isBypassRadiusAuth'
        },
        expiration: {
            pageId: 'expiration',
            hasExpiration: 'hasExpiration',
            subscriptionPeriod: 'subscriptionPeriod',
            subscriptionPeriodUnit: 'subscriptionPeriodUnit',
            subscriptionPeriodUnitValues: {
                hours: 'Hours',
                days: 'Days',
                months: 'Months'
            },
            startMode: 'startMode',
            startModeValues: {
                firstLogin: 'FirstLogin',
                specifiedDate: 'SpecifiedDate'
            },
            startDate: 'startDateAndTime',
            userFirstLogin: 'userFirstLogin'
        },
        contact: {
            pageId: 'contact',
            phone: 'phone',
            mobile: 'mobile',
            fax: 'fax',
            address: 'address',
            country: 'country',
            state: 'state',
            zip: 'zip'
        },
        twoStepAuth: {
            pageId: 'twoStepAuth',
            isTwoFactorAuth: 'isTwoFactorAuth',
            twoFactorAuthQrUrl: 'twoFactorAuthQrUrl'
        },
        status: {
            pageId: 'status',
            statusDataList: 'statusDataList',
            statusDataSchema: {
                uid: 'uid',
                appName: 'appName',
                creationTime: 'creationTime',
                lastUsedTime: 'lastUsedTime',
                remoteAddress: 'remoteAddress'
            },
            createdDate: 'createdDate',
            modifiedDate: 'modifiedDate'
        },
        customFields: {
            pageId: 'customFields',
            customFieldOne: 'customField1',
            customFieldTwo: 'customField2',
            customFieldSchema: {
                name: 'name',
                value: 'value'
            }
        }
    }
}

export const UserGetListSchema = {
    name: 'name',
    description: 'description',
    firstName: 'firstName',
    lastName: 'lastName',
    company: 'company',
    email: 'email',
    phone: 'phone',
    role: 'role',
    roleDn: 'roleDn',
    status: 'status'
}

export const UserCreateSchema = {
    name: 'name',
    firstName: 'firstName',
    lastName: 'lastName',
    email: 'email',
    role: 'role',
    password: 'password',
    enableTwoStepAuthentication: 'enableTwoStepAuthentication'
}

export const UserStatuses = {
    connected: 'connected',
    disconnected: 'disconnected',
    disabled: 'disabled'
}

export const UserFilterSchema = {
    freeTextSearch: 'freeTextSearch',
    role: 'role',
    creationDate: 'creationDate',
    modificationDate: 'modificationDate'
}